import {
  GetContinueWatchingCollectionDocument,
  UpdateContinueWatchingItemDocument,
} from '#types/generated/apollo-client';
import { UpdateContinueWatchingItemParams } from '#types';
import { getApolloClient } from '#providers/apollo/initializeClient';

export const api = {
  async getAll(profileId: number) {
    const client = getApolloClient();
    const { data } = await client.query({
      query: GetContinueWatchingCollectionDocument,
      variables: {
        params: {
          profileId,
        },
      },
      fetchPolicy: 'network-only',
    });

    return data.continueWatchingCollection.items.map((item) => ({ ...item }));
  },
  async updateItem(
    profileId: number,
    payload: UpdateContinueWatchingItemParams
  ) {
    const client = getApolloClient();
    const { data } = await client.mutate({
      mutation: UpdateContinueWatchingItemDocument,
      variables: {
        params: {
          profileId,
          ...payload,
        },
      },
      fetchPolicy: 'network-only',
    });

    return data.updateContinueWatchingItem;
  },
};
